import { TrackingState } from '../../../models';
import { TRACKING_MUTATIONS_KEYS } from '../tracking.const';
import { TrackingMutation } from '../tracking.interfaces';

export class SaveProductPageResultIdMutation implements TrackingMutation {

  mutations = {
    [TRACKING_MUTATIONS_KEYS.saveProductPageResultId]: (localState: TrackingState, resultId: string): void => {
      localState.productPageResultId = resultId;
    }
  };
}
